import { Graphics } from 'pixi.js';

export function updatePlayerGraphicFill(graphic: Graphics, ratio: number, size: number) {
	const clamped = Math.max(0, Math.min(1, ratio));
	const fillHeight = size * clamped;
	const top = -size / 2;
	const left = -size / 2;
	graphic.clear();
	if (fillHeight > 0) {
		const y = top + (size - fillHeight);
		graphic.rect(left, y, size, fillHeight);
		graphic.fill({ color: 0x38bdf8, alpha: 0.85 });
	}
	graphic.roundRect(left, top, size, size, 8);
	graphic.stroke({ color: 0x38bdf8, alpha: 0.85, width: 2, alignment: 1 });
}


